/* tslint:disable:max-line-length */

import {getPrefectureName, setSessionStorage} from '../util/Natutil'
import {NatPostResidentLogin} from '../../components/login/repository/NatPostResidentLogin'
import {Nullable} from '../../../app/TypeHelpers'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {NatPostResidentCondominiumSelect} from '../../components/session/repository/NatPostResidentCondominiumSelect'

export const ResidentLoginInfoSessionStorageKey = {
    AUTHORITIES: 'AUTHORITIES',
    ROLE: 'role',
    LOGIN_MODE: 'loginMode',
    LOGIN_USER_RESIDENT_USER_TYPE: 'loginUserResidentUserType',
    LOGIN_ROLE_NAME: 'loginRoleName',
    LOGIN_FAMILY_NAME: 'loginFamilyName',
    LOGIN_FIRST_NAME: 'loginFirstName',
    SELECTED_CONDOMINIUM_CD: 'selectedCondominiumCd',
    SELECTED_CONDOMINIUM_NAME: 'selectedCondominiumName',
    SELECTED_RIDGECD: 'selectedRidgeCd',
    SELECTED_RIDGENAME: 'selectedRidgeName',
    SELECTED_ROOM_NUMBER: 'selectedRoomNumber',
    SELECTED_CONDOMINIUM_ZIP_CODE: 'selectedCondominiumZipCode',
    SELECTED_CONDOMINIUM_ADDRESS_PREFECTURE: 'selectedCondominiumAddressPrefecture',
    SELECTED_CONDOMINIUM_ADDRESS_ADDRESS2: 'selectedCondominiumAddressAddress2',
    SELECTED_CONDOMINIUM_ADDRESS_ADDRESS3: 'selectedCondominiumAddressAddress3',
    SELECTED_CONDOMINIUM_IMAGE: 'selectedCondominiumImage',
    FACILITY_RESERVE_AVAILABILITY: 'facilityReserveAvailability',
    LOGIN_USER_MAIL_ADDRESS_DOMAIN: 'loginUserMailAddressDomain',
    SELECTED_CONDOMINIUM_BOARD_USER_DISP: 'selectedCondominiumBoardUserDisplay',
    ASSOC_DIRECTOR_FLAG: 'assocDirectorFlag',
    BOARD_RESIDET_AUTHORITY: 'boardResidentAuthority',
    BOARD_ADMIN_AUTHORITY: 'boardAdminAuthority',
    LOGIN_USER_ID: 'userId',
} as const
type ResidentLoginInfoSessionStorageKey =
    typeof ResidentLoginInfoSessionStorageKey[keyof typeof ResidentLoginInfoSessionStorageKey];

export class NatResidentLoginInfoSessionStorageHelper {

    static getStringItemOrNull(key: ResidentLoginInfoSessionStorageKey): Nullable<string> {
        return SessionStorageHelper.getStringItemOrNull(key)
    }

    static getNumberItemOrNull(key: ResidentLoginInfoSessionStorageKey): Nullable<number> {
        return SessionStorageHelper.getNumberItemOrNull(key)
    }

    static setSessionStorage(residentLoginUserInfo: NatPostResidentLogin): void {
        this.setSessionStorageUserInfo(residentLoginUserInfo)

        if (residentLoginUserInfo.condominiumCd) {
            this.setSessionStorageCondominiumInfo(residentLoginUserInfo)
        }
    }

    static setSessionStorageByKey(key: ResidentLoginInfoSessionStorageKey, value: any): void {
        setSessionStorage(key, value)
    }

    static setSessionStorageUserInfo(residentLoginUserInfo: NatPostResidentLogin): void {
        setSessionStorage(ResidentLoginInfoSessionStorageKey.LOGIN_MODE, residentLoginUserInfo.loginMode)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.LOGIN_FAMILY_NAME, residentLoginUserInfo.familyName)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.LOGIN_FIRST_NAME, residentLoginUserInfo.firstName)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.LOGIN_USER_ID, residentLoginUserInfo.userId)
    }

    static setSessionStorageCondominiumInfo(residentLoginUserInfo: NatPostResidentLogin | NatPostResidentCondominiumSelect): void {
        const prefectureName = residentLoginUserInfo.prefectureCd ? getPrefectureName(residentLoginUserInfo.prefectureCd) : ''

        setSessionStorage(ResidentLoginInfoSessionStorageKey.AUTHORITIES, JSON.stringify(residentLoginUserInfo.authority))
        setSessionStorage(ResidentLoginInfoSessionStorageKey.ROLE, residentLoginUserInfo.role)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.LOGIN_ROLE_NAME, residentLoginUserInfo.roleName)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.LOGIN_USER_RESIDENT_USER_TYPE, residentLoginUserInfo.residentUserType)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD, residentLoginUserInfo.condominiumCd)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME, residentLoginUserInfo.condominiumName)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGECD, residentLoginUserInfo.ridgeCd)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME, residentLoginUserInfo.ridgeName)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER, residentLoginUserInfo.roomNumber)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_ZIP_CODE, residentLoginUserInfo.zipcode)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_ADDRESS_PREFECTURE, prefectureName)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_ADDRESS_ADDRESS2, residentLoginUserInfo.address2)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_ADDRESS_ADDRESS3, residentLoginUserInfo.address3)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_IMAGE, residentLoginUserInfo.imagePath)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.FACILITY_RESERVE_AVAILABILITY, residentLoginUserInfo.facilityReserveAvailability)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_BOARD_USER_DISP, residentLoginUserInfo.boardUserDisplay)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.ASSOC_DIRECTOR_FLAG, residentLoginUserInfo.assocDirectorFlag)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.BOARD_RESIDET_AUTHORITY, residentLoginUserInfo.boardResidentAuthority)
        setSessionStorage(ResidentLoginInfoSessionStorageKey.BOARD_ADMIN_AUTHORITY, residentLoginUserInfo.boardAdminAuthority)
    }

    static setSessionStorageMailAddressDomain(mailAddress: string | null): void {
        if (mailAddress) {
            setSessionStorage(ResidentLoginInfoSessionStorageKey.LOGIN_USER_MAIL_ADDRESS_DOMAIN, mailAddress.split('@')[1])
        } else {
            setSessionStorage(ResidentLoginInfoSessionStorageKey.LOGIN_USER_MAIL_ADDRESS_DOMAIN, '')
        }
    }
}
